import nodeFetch from "node-fetch";
import { getAuthToken } from "./auth-utils";
 
export function request(url, options, context) {
  if (context) {
    const token = getAuthToken(context.req);
    options.headers = { ...options.headers, authorization: token };
  }
  return nodeFetch(url, options);
}

export async function customFetch(url, options, dispatch) {
  const response = await fetch(url, options);
  if (response.ok) {
    return response;
  } else {
    if (dispatch) {
      const error = await response.json();
    
      if (response.status == 401) {
        //TODO for logout
        return;
      }
      //dispatch(setError(error));
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    return response;
  }
}
